import { useEffect, useState } from 'react';
import {
  BILLING_JOB_POLL_INTERVAL_MS,
  PAUSE_POLLING_WHEN_UNFOCUSED,
} from 'src/constants/polling.constants';
import { useGetBillingJobStatusQuery } from '../endpoints/billing.endpoints';
import type { BillingJobStatusValue } from 'src/redux/billing/billing.types';

const IN_PROGRESS_STATUSES: BillingJobStatusValue[] = [
  'pending',
  'fetching_data',
  'generating_invoices',
];

export function isBillingJobInProgress(status?: BillingJobStatusValue | null): boolean {
  return status != null && IN_PROGRESS_STATUSES.includes(status);
}

export function useBillingJobProgress(invoiceGroupId: string) {
  const [pollingInterval, setPollingInterval] = useState(0);

  const { data, isError } = useGetBillingJobStatusQuery(invoiceGroupId, {
    skip: !invoiceGroupId,
    pollingInterval,
    ...PAUSE_POLLING_WHEN_UNFOCUSED,
  });

  useEffect(() => {
    setPollingInterval(
      isBillingJobInProgress(data?.status) ? BILLING_JOB_POLL_INTERVAL_MS : 0,
    );
  }, [data?.status]);

  const isInProgress = !isError && isBillingJobInProgress(data?.status);

  return {
    status: data?.status,
    isInProgress,
  };
}
